'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');
var addressConsts = require('@shopify/address-consts');
var graphqlQuery = require('./graphqlQuery.js');

const loadCountries = memoizeAsync( /*#__PURE__*/function () {
  var _ref = _rollupPluginBabelHelpers.asyncToGenerator(function* (locale) {
    const response = yield fetch(addressConsts.GRAPHQL_ENDPOINT, {
      method: 'POST',
      headers: addressConsts.HEADERS,
      body: JSON.stringify({
        query: graphqlQuery["default"],
        operationName: addressConsts.GraphqlOperationName.Countries,
        variables: {
          locale: locale.replace(/-/, '_').toUpperCase()
        }
      })
    });
    const countries = yield response.json();

    if (!('data' in countries) && 'errors' in countries) {
      throw new CountryLoaderError(countries);
    }

    return countries.data.countries;
  });

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
const loadCountry = memoizeAsync( /*#__PURE__*/function () {
  var _ref2 = _rollupPluginBabelHelpers.asyncToGenerator(function* (locale, countryCode) {
    const response = yield fetch(addressConsts.GRAPHQL_ENDPOINT, {
      method: 'POST',
      headers: addressConsts.HEADERS,
      body: JSON.stringify({
        query: graphqlQuery["default"],
        operationName: addressConsts.GraphqlOperationName.Country,
        variables: {
          countryCode,
          locale: locale.replace(/-/, '_').toUpperCase()
        }
      })
    });
    const country = yield response.json();

    if (!('data' in country) && 'errors' in country) {
      throw new CountryLoaderError(country);
    }

    return country.data.country;
  });

  return function (_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}());
class CountryLoaderError extends Error {
  constructor(errors) {
    const errorMessage = errors.errors.map(error => error.message).join('; ');
    super(errorMessage);
  }

}

function memoizeAsync(asyncFunction) {
  const cache = {};
  return (...args) => {
    const stringifiedArgs = JSON.stringify(args);

    if (!cache[stringifiedArgs]) {
      cache[stringifiedArgs] = asyncFunction.apply(this, args);
    }

    return cache[stringifiedArgs];
  };
}

exports.CountryLoaderError = CountryLoaderError;
exports.loadCountries = loadCountries;
exports.loadCountry = loadCountry;
